import FaceCaptureNoAi from "../../components/CaptureNoAI/FaceCaptureNoAi";

const CaptureNoAI = () => {
	return (
		<div className="faceContainer">
			<FaceCaptureNoAi />
		</div>
	);
};

export default CaptureNoAI;
